const API = process.env.REACT_APP_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = "https://api.mishovmarkets.com/api";
// const SERVER_DOMAIN = "https://api.mishovmarkets.com"; 
const SERVER_DOMAIN = ""; // clear for new upload storage
const APPOINTMENT_BACKEND_URL = process.env.REACT_APP_APPOINTMENT_API_URL

export { API, SERVER_DOMAIN, BACKEND_URL, APPOINTMENT_BACKEND_URL };
